import { EffectDef, makeGain } from './types';

/** Flanger: LFO-modulated ~2–6 ms delay with feedback. */
export const flanger: EffectDef = {
  type: 'flanger',
  name: 'Flanger',
  params: [
    { key: 'rate', label: 'Rate', min: 0.05, max: 8, default: 0.6, step: 0.05, unit: 'Hz' },
    { key: 'depth', label: 'Depth', min: 0, max: 1, default: 0.7, step: 0.01 },
    { key: 'feedback', label: 'Fdbk', min: 0, max: 0.9, default: 0.4, step: 0.01 },
    { key: 'wet', label: 'Wet', min: 0, max: 1, default: 0.35, step: 0.01 },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const dry = makeGain(ctx, 1 - p.wet);
    const wetIn = makeGain(ctx, 1);
    const delayNode = ctx.createDelay(0.05);
    const feedback = makeGain(ctx, p.feedback);
    const wetOut = makeGain(ctx, p.wet);
    const lfo = ctx.createOscillator();
    const lfoGain = makeGain(ctx, 0);

    const base = 0.002;
    delayNode.delayTime.value = base;
    lfo.frequency.value = p.rate;
    lfo.start();

    input.connect(dry);
    dry.connect(output);
    input.connect(wetIn);
    wetIn.connect(delayNode);
    delayNode.connect(wetOut);
    wetOut.connect(output);
    delayNode.connect(feedback);
    feedback.connect(delayNode);
    lfo.connect(lfoGain);
    lfoGain.connect(delayNode.delayTime);

    const apply = (params: Record<string, number>) => {
      lfo.frequency.value = params.rate;
      lfoGain.gain.value = params.depth * 0.004; // ±4 ms swing
      feedback.gain.value = params.feedback;
      dry.gain.value = 1 - params.wet;
      wetOut.gain.value = params.wet;
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        try {
          lfo.stop();
        } catch {
          /* already stopped */
        }
        lfo.disconnect();
        lfoGain.disconnect();
        delayNode.disconnect();
        feedback.disconnect();
        dry.disconnect();
        wetIn.disconnect();
        wetOut.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};